import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Leaf, Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("anandmdu@gmail.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      localStorage.setItem("ng_admin_token", res.data.token);
      localStorage.setItem("ng_admin_email", res.data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(errMsg(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left visual */}
      <div className="relative hidden lg:block">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1518843875459-f738682238a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
          }}
        />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(15,46,32,0.65)" }} />
        <div className="relative h-full p-14 flex flex-col justify-between text-bone">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center overflow-hidden">
              <img
                src="https://customer-assets-lqy194kg.emergentagent.net/job_produce-hub-97/artifacts/apfk1p9h_Saravana_Stores_HQ.png"
                alt="Saravana Stores"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <div className="font-serif text-2xl leading-none">Saravana Stores</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-bone/70 mt-1">Farmer's Market</div>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.28em] text-bone/70 mb-3">Admin console</div>
            <h1 className="font-serif text-5xl leading-tight">
              Stock the shelves.<br />
              Watch the numbers.
            </h1>
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="bg-bone flex items-center justify-center p-8">
        <form onSubmit={login} className="w-full max-w-sm" data-testid="admin-login-form">
          <div className="mb-8">
            <div className="inline-flex items-center gap-2 text-forest">
              <Lock className="w-4 h-4" />
              <span className="text-xs uppercase tracking-[0.24em]">Secure sign-in</span>
            </div>
            <h2 className="mt-3 font-serif text-3xl text-charcoal">Admin login</h2>
          </div>
          <div className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
              />
            </div>
            <div>
              <Label>Password</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full mt-6 h-11 text-white rounded-md"
            style={{ backgroundColor: "var(--forest)" }}
          >
            {busy ? "Signing in…" : "Sign in"}
          </Button>
          <a
            href="/"
            className="block mt-6 text-center text-xs uppercase tracking-[0.24em] text-charcoal/50 hover:text-forest"
          >
            ← Back to store
          </a>
        </form>
      </div>
    </div>
  );
}
